import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { RIConfirmarEquipoContent } from './components/RIConfirmarEquipoContent';

export default function RIConfirmarEquipoDetalle() {
    return (
        <>
            <MainContent
                component={<RIConfirmarEquipoContent />}
                titulo='Confirmar equipo'
                noBackground
                tableMaxWidth
            />
        </>
    );

};
